import { SOPORTO_KING_APP_ID } from './constants';

function handleResponse(response) {
    if (response.ok) {
        return response.json();
    } else {
        throw Error(response.statusText);
    }
}

export default {
    submitFormData: function (data, token, successCb, errorCb) {
        fetch(`/api/case?captchaToken=${token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(handleResponse)
            .then(successCb)
            .catch(errorCb);
    },

    submitDeleteAccountRequest: function (data, game, sessionKeyData, successCb, errorCb) {
      fetch(`/api/help/games/${game}/cases?kingApp=${game}&sessionKeyData=${sessionKeyData}`, {
          method: 'POST',
          headers: {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify(data)
      })
              .then(handleResponse)
              .then(successCb)
              .catch(errorCb);
    },

    getUserData: function (sessionKeyData, successCb, errorCb) {
        fetch(
            `/api/help/games/${SOPORTO_KING_APP_ID}/init?kingApp=${SOPORTO_KING_APP_ID}&sessionKeyData=${sessionKeyData}`,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        )
            .then(handleResponse)
            .then(successCb)
            .catch(errorCb);
    },

    getJWT: function (token, email, successCb, errorCb) {
        fetch(`/api/jwt?captchaToken=${token}&email=${email}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(handleResponse)
            .then(successCb)
            .catch(errorCb);
    }
};



// WEBPACK FOOTER //
// ./src/requests.js